import React, { useEffect } from "react";
import TableSearchInput from "../TableSearchInput";

const OrderSearchInput = ({
  setSearchValue,
  updateRefreshKey,
  query,
  setQuery,
  showInput,
  setShowInput,
}) => {
  const handleInputChange = (e) => {
    setQuery(e.target.value);
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      setSearchValue(query);

      if (query.trim() === "") {
        updateRefreshKey((key) => key + 1);
      }
    }, 400);

    return () => clearTimeout(timer);
  }, [query, setSearchValue, updateRefreshKey]);

  return (
    <TableSearchInput
      searchQuery={query}
      onSearchChange={handleInputChange}
      tooltip="Search Order Code, Customer Name, Driver Name"
      placeholder="Search Order Code, Customer Name, Driver Name"
    />
  );
};

export default OrderSearchInput;